// helper function to access the resource with the token
export function callApiWithAccessToken(endpoint: string, token: any) {
  const headers = new Headers();
  const bearer = `Bearer ${token}`;

  headers.append('Authorization', bearer);

  const options = {
    method: 'GET',
    headers: headers,
  };

  fetch(endpoint, options)
    .then((response) => response.json())
    .catch(() => {});
}
